import myGlobals from './globals';
import { callReduxAlertActionWithParameter } from '../App';
import { myFormValidations } from '.';
let fieldsThatNeedCurrency = new Set(["payableAmount","discountAmount","totalConvienceFee","disputeAmount2","totalSurchargeAmount","total", "invoiceAmount", "totalLateFee"]);
function needCurrency(fieldName){
    if(fieldsThatNeedCurrency.has(fieldName))
        return myGlobals.globalCurrencySymbol;
    else
        return "";
}

export const PAYMENT_METHOD_CC = 'CREDITCARD';
export const PAYMENt_METHOD_DC = 'DEBITCARD';
export const PAYMENT_METHOD_ACH = "ACH";
export const DEFAULT_COUNTRY_CODE = "US";
export const USA_COUNTRY_CODE = "US";
export const CANADA_COUNTRY_CODE = "CA";

export const PaymentStatuses = {
  IN_PROGRESS_STATUS: "In-Progress".toLowerCase(),
  SUCCESS_STAUS: "Success".toLowerCase(),
};

function accountSpecificLanguage(id="",defaultMessage){
    try{
    	let mess = myGlobals.messages[`${myGlobals.globalAccountId}_${id}`];
    	if(!mess)
            mess = myGlobals.messages[`${id}`];
        if(mess)
            return mess;
        else
            throw new Error("Message not found in account specific bundle for id: "+id);
    }
    catch(err){
        console.log(err);
        return id === "" ? "" : defaultMessage;
    }
}
function accountSpecificLanguagePlaceholders(id="",defaultMessage="", placeHolders = {}){
    try{
    	let mess = myGlobals.messages[`${myGlobals.globalAccountId}_${id}`];
    	if(!mess)
            mess = myGlobals.messages[`${id}`];
        let keys  = Object.keys(placeHolders);
        let values = Object.values(placeHolders);
        for(let i = 0; i < keys.length; i++) {
            mess = mess.replace(new RegExp('{' + keys[i] + '}', 'gi'), values[i]);
        }
        if(mess)
            return mess;
        else
            throw new Error("Message not found in account specific bundle with placeholder for id: "+id);
    }
    catch(err){
        console.log(err);
        return id === "" ? "" : defaultMessage;
    }
}
const substituteThousand = (number) => {
	  let decimalIndex = number.indexOf(".");
	  return Math.abs(number) < 999
	    ? number
	    : number.substring(0, decimalIndex - 3) +
	        "$" +
	        number.substring(decimalIndex - 3, number.length);
	};
const custommFormatCurrency = (
		  amount,
		  thousands = ",",
		  decimal = ".",
		  parseValue = 2
		) => {
		  try {

		    let num = parseFloat(
		        (amount = Math.abs(Number(amount) || 0))
		    ).toFixed(parseValue);
		    amount = num.toString().replace('-', '#');
			if(parseValue != 0) // there are decimal values
		    	amount = substituteThousand(amount);
		    amount= amount.replace(".", decimal);
		    amount= amount.replaceAll("$", thousands);
		    amount= amount.replace("#", '-');
		    return amount;
		  } catch (e) {
		    console.log(e);
		    return amount;
		  }
		};

const getFormattedAmount = (custommFormat, amount) => {
		    if(custommFormat !== undefined && custommFormat !== null) {
		        if(custommFormat === '0\'000.00') {
		            amount = custommFormatCurrency(amount, "\'", ".");
		        } else if (custommFormat === '0 000.00') {
		            amount = custommFormatCurrency(amount, " ", ".");
		        } else if (custommFormat === '0,000/00') {
		            amount = custommFormatCurrency(amount, ",", "/");
		        }else if (custommFormat === '0 000-00') {
		            amount = custommFormatCurrency(amount, " ", "-");
		        }else if (custommFormat === '0 000,00') {
		            amount = custommFormatCurrency(amount, " ", ",");
		        }else if (custommFormat === '0.000,00' || custommFormat === '00.000,00') {
		            amount = custommFormatCurrency(amount, ".", ",");
		        } else if(custommFormat === '0,000,000'){
					amount = custommFormatCurrency(amount, ",", ".", 0);
				} else if (custommFormat === '0,00,000.00' || custommFormat === '0,00,000' || custommFormat === '00,00,000.0') {
		            let toFixedSize = custommFormat === '0,00,000.00' ? 2 : custommFormat === '0,00,000' ? 0 : 1;
		            amount = parseFloat(amount).toFixed(toFixedSize);
		            amount = parseFloat(amount).toLocaleString('en-IN');
		        }
		        else if (custommFormat === "0,000.00" || custommFormat === "000,000.00")
		            amount = custommFormatCurrency(amount, ",", ".");
		        else if(custommFormat === "0000,00") {
		            amount = parseFloat(amount).toFixed(0);
		            amount = parseFloat(amount).toLocaleString('en-US');
		        }
		    }
		    return amount;
}
function toStringUtil(data,fieldName){
    if(data===undefined || data===null)
        return "";
    else {
    	data = data.toString();
        if(fieldsThatNeedCurrency.has(fieldName)){
        	if(myGlobals.amountFormat === "" ) {
	            if(data.indexOf(".") != -1){
	                return parseFloat(data.substring(0,data.indexOf("."))).toLocaleString("en-US") + data.substring(data.indexOf("."), data.indexOf(".")+3);  
	            }else{
	                return parseFloat(data).toLocaleString("en-US");  
	            }
        	}else return getFormattedAmount(myGlobals.amountFormat, data);
        }
        else{
            return data.toString();
        }
    }
}
const removeArrayElement = (array, n) => {
    var index = array.indexOf(n);
    if (index > -1) {
      array.splice(index, 1);
    }
    return array;
  };
const getParameter = (paramName) => {
	  var searchString = window.location.search.substring(1),
	  i,
	  val,
	  params = searchString.split("&");

	  for (i = 0; i < params.length; i++) {
		  val = params[i].split("=");
		  if (val[0] == paramName) {
			  return val[1];
		  }
	  }
	  return null;
  };
  const checkTransactionLimit = (paymentMethod, invData) => {
	    let currencyAndPaymentLimitMap = new Map();
	    if (
	      myGlobals.paymentLimitsMap !== undefined &&
	      Object.keys(myGlobals.paymentLimitsMap).length > 0
	    ) {
	      currencyAndPaymentLimitMap = myGlobals.paymentLimitsMap[paymentMethod];
	      if(currencyAndPaymentLimitMap != null && currencyAndPaymentLimitMap != undefined){
		      let currencySymbol = myGlobals.globalCurrencySymbol;
		      let transactionLimit = currencyAndPaymentLimitMap[invData.state.currency];
		      if (
		        undefined !== transactionLimit &&
		        invData.state.total > transactionLimit
		      ) {
		        callReduxAlertActionWithParameter(
		          "Alert.TransactionLimit",
		          "Please use other payment modes",
		          {
		            currencySymbol: currencySymbol,
		            transactionLimit: transactionLimit,
		          }
		        );
		        return -1;
		      }
	    	}
	    }
	    return 0;
	  };
	  const numericAndBlackListedCheck = (itemName, isNumeric, value) => {
		    let allowToBeEntered = false;
		    let blacklisted = new RegExp(myFormValidations.getBlacklisted(itemName));
		    
		    if (!blacklisted.test(value)) {
		      if (isNumeric) {
		        if (!Number.isNaN(Number(value)) )
		          allowToBeEntered = true;
		      } else allowToBeEntered = true;
		    }
		    return allowToBeEntered;
		  };
const isValidString = inputStr => {
	return Boolean(inputStr);
}
export default {
    needCurrency: needCurrency,
    accountSpecificLanguage: accountSpecificLanguage,
    toStringUtil: toStringUtil,
    addNotification: ()=>{console.log('Notification System Not Setup Yet')},
    removeArrayElement: removeArrayElement,
    getParameter: getParameter,
    accountSpecificLanguagePlaceholders: accountSpecificLanguagePlaceholders,
	checkTransactionLimit: checkTransactionLimit,
    numericAndBlackListedCheck: numericAndBlackListedCheck,
	isValidString: isValidString
}